import { calculateFinances, UserData } from '../../../constants';

const S80c2 = {
  label: 'Your Tax Savings (80C)',
  sections: [
    {
      type: 'text',
      text: (data: UserData) => {
        const taxData = calculateFinances(data);
        return `
        <h5 class="mb20">How? By investing in Tax Saving Mutual Funds suggested by ClearTax</h5>
        <div class="tax-savings-block" style="height: 240px; margin-top: -25px;">
          <div class="left-block">You saved <b>Rs.${taxData.initialTaxSavings.toLocaleString(
            'en-IN'
          )}</b> by tax savings.
          </div>
          <div class="right-block">You could save <b>Rs.${taxData.taxSavings.toLocaleString(
            'en-IN'
          )}</b>
          more tax & earn up to <b>Rs.${taxData.additionalIncome.toLocaleString(
            'en-IN'
          )}</b> returns if you had invested on ClearTax last year.
          </div>
        </div>
        <br />
        `;
      },
      action: {
        URLParams: `startInvest=1&planId=19&ref=personalised-plan&ref2=growth-button-2${
          typeof window !== 'undefined' && window.recommendationsKey
            ? `&story=${window.recommendationsKey}`
            : ''
        }`,
        label: 'View Recommended Plan',
      },
    },
  ],
};

export default S80c2;



// WEBPACK FOOTER //
// ./components/recommendation/cards/80c2.ts